/**
 * Planned size distribution of a production order (spec 0040 §2.2).
 * Subcollection: org/{orgId}/production-order/{productionOrderId}/breakdown
 *
 * Structural mirror of `SalesOrderItemBreakdown` (spec 0031 §4.5): lean, no
 * lifecycle. Materialized only for products with a size grid. Resolve the
 * repository with context `{ orgId, productionOrderId }`.
 * Audit via {@link Auditable} / ChildCrudService (request 0238).
 */
export const PRODUCTION_ORDER_BREAKDOWN = 'ProductionOrderBreakdown';
//# sourceMappingURL=production-order-breakdown.js.map